import i18next from "i18next";
import * as extractionsServices from "../../services/extractionsServices";
import { useEffect, useState } from "react";
import Autocomplete from "../../components/Autocomplete";
import { capitalize } from "@mui/material";
import MultiSelect from "../../components/MultiSelect";
import useDebouncedFunction from "../../hooks/useDebouncedFunction";

interface ExtractionsSelectProps {
	value?: any;
	showValue?: any;
	onChange?: any;
	error?: any;
	multiple?: boolean;
	renderValue?: (value: any) => JSX.Element;
	required?: boolean;
}

const ExtractionSelect = ({
	multiple,
	value = [],
	showValue,
	onChange,
	error,
	renderValue,
	required,
}: ExtractionsSelectProps) => {
	const [extractions, setExtractions] = useState<any>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!showValue) {
			handleChangeSearch({ target: { value: "" } });
		}
	}, [showValue]);

	const handleChangeSearch = async (e: any) => {
		const value = e?.target?.value ?? "";
		setLoading(true);
		var extractions = await extractionsServices.search({ skip: 0, limit: 10, search: value });
		extractions = extractions.result.map((extraction) => ({
			label: extraction.code + " - " + capitalize(i18next.t(extraction.type_extraction)),
			value: { name: extraction.code + " - " + capitalize(i18next.t(extraction.type_extraction)), ...extraction },
			...extraction,
		}));
		setExtractions(extractions);
		setLoading(false);
	};

	const debouncedSearch = useDebouncedFunction(handleChangeSearch);

	if (multiple)
		return (
			<MultiSelect
				options={extractions.filter((g) => !value.map((g) => g.id).includes(g.id))}
				placeholder={i18next.t("entity-search", { entity: i18next.t("Extraction") })}
				datatestid={"search-extraction-input"}
				label={i18next.t("extractions")}
				value={value}
				onInputChange={(e) => {
					setLoading(true);
					debouncedSearch(e);
				}}
				renderValue={(value) => <div>{value.map(({ name }) => name).join(", ")}</div>}
				showValue={showValue}
				onChange={onChange}
				error={error}
				loading={loading}
				required={required}
			/>
		);

		return (
		<Autocomplete
			error={error}
			className="mt-3"
			id="extraction"
			onInputChange={(e) => {
				setLoading(true);
				debouncedSearch(e);
			}}
			required={required}
			options={extractions}
			datatestid={"search-extraction-input"}
			onChange={onChange}
			placeholder={i18next.t("entity-search", { entity: i18next.t("Extraction") })}
			label={i18next.t("extraction")}
			value={value}
			showValue={showValue}
			renderValue={(value) => (renderValue ? renderValue(value) : <div>{value.name}</div>)}
			loading={loading}
		/>
	);
};

export default ExtractionSelect;
